// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3gP3D","addWidgetButton":"Header_addWidgetButton__1RBb5","dashboardTabs":"Header_dashboardTabs__2fWF0","active":"Header_active__ae2gX"};